module.exports = __webpack_public_path__ + "img/Number=105.34d077f9.png";